import React, { useState } from 'react';
import { Card, CardContent } from '../ui/card';
import Image from 'next/image';
import { Button } from '../ui/button';
import { CommitmentData } from '@/types/commitments';
import fixNewsContent from '@/lib/SVG_Render';
// Memoize the component to prevent unnecessary re-renders
export const SocialCard = React.memo(function SocialCard(props: CommitmentData) {
    const { id, title, content, media } = props;
    const [isOpen, setIsOpen] = useState(false);
    const isOdd = id % 2 === 0; 

    // Extract image URL and provide a robust fallback
    const imageUrl = media?.[0]?.url || '/default.jpg';
   
    const blurUrl = "/default.jpg"; 

    return (
        <Card className='border md:border-ring p-4'>
            <CardContent
                className={`px-0 gap-4 md:gap-6 lg:gap-10 w-full ${isOpen ? "flex flex-col items-center md:items-start" : "flex"} ${!isOdd ? "md:flex-row-reverse" : "md:flex-row"}`}
            >
                <div className=''>
                    <div className='relative h-32 md:h-44 w-32 md:w-44 flex-shrink-0'> 
                        <Image
                            src={imageUrl}
                            
                            placeholder={blurUrl ? "blur" : "empty"}
                            blurDataURL={blurUrl} 
                            loading='lazy' 
                            alt={title || "social image"} 
                            fill
                            sizes="(max-width: 768px) 128px, 176px" 
                            className="object-cover rounded-md" 
                            
                        />
                    </div>
                </div>
                <div className={`flex flex-col h-full w-full space-y-4 md:space-y-6`}>
                    <h2 className={`font-semibold text-sm md:text-base text-foreground ${isOpen ? "line-clamp-none" : "line-clamp-2 md:line-clamp-none"} leading-relaxed`}>
                        {title}
                    </h2>
                    
                    {content && ( 
                        <div
                            className={`text-xs sm:text-sm leading-relaxed text-muted-foreground ${isOpen ? "line-clamp-none" : "line-clamp-2 md:line-clamp-3"}`}
                            dangerouslySetInnerHTML={{ __html: fixNewsContent(content) }}
                        />
                    )}
                    <Button
                        onClick={() => setIsOpen(!isOpen)}
                        className="text-white bg-primary hover:bg-prime-hover cursor-pointer rounded-full w-fit"
                    >
                        {isOpen ? "Read Less" : "Read More"}
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
});

export default SocialCard;